import { PayloadAction } from 'typesafe-actions';
import { 
  STORE_RESULT_LIDZOEKEN, 
  CLEAR_LIDZOEKEN, 
  START_LIDZOEKEN, 
  STOP_LIDZOEKEN, 
  SET_CONSENT_LIDZOEKEN,
  PASSTHROUGH_FIELD_LIDZOEKEN 
} from '../constants/Constants';

type LidZoekenResult = {
  PersoonsId?: string;
  EmailLead?: string;
  LeadLidnummer?: string;
  PersoonLidnummer?: string;
  Lidmaatschapsnummer?: string;
  PageNumber: number;
  LidgaatAkkoord?: boolean;
  result: LidZoekenResultResult;
};

type LidZoekenResultResult = {
  PersoonsId?: string;
  FormGuid?: string;
};

type LidZoekenState = {
  results: LidZoekenResult[];
  isSearching: boolean;
  additionalFormData?: any;
  pageNumber?: number;
  totalAmountOfResults?: number;
};

type LidZoekenPayload = {
  id?: string;
  consent?: boolean;
  fieldName?: string;
  value?: string;
  results: LidZoekenResult[];
  zoekenOp?: string;
  lidnummer?: string;
  postcode?: string;
  huisnummer?: string;
  geboortedatum?: string;
  searchValue?: string;
  formName?: string;
  additionalData?: any;
};

function updateResults(stateResults: LidZoekenResult[], payloadResults: LidZoekenResult[]) : any {
  if(payloadResults[0].PageNumber > 1) {
    return [...stateResults, ...payloadResults.filter((obj2) => {
      if(obj2.LeadLidnummer !== undefined && !stateResults.some((obj1) => obj1.LeadLidnummer !== undefined && obj1.LeadLidnummer === obj2.LeadLidnummer)){
        return true;
      }
      if(obj2.PersoonLidnummer !== undefined && !stateResults.some((obj1) => obj1.PersoonLidnummer !== undefined && obj1.PersoonLidnummer === obj2.PersoonLidnummer)){
        return true;
      }
      return false;
    })];
  } else {
    const results = payloadResults.filter(res => {
      if(res.LeadLidnummer !== undefined || res.PersoonLidnummer !== undefined || res.Lidmaatschapsnummer !== undefined){
        return true;
      }
    });
    return results;
  }
}

export const lidZoekenReducer = (state: LidZoekenState = { results: [], isSearching: false }, action: PayloadAction<string, LidZoekenPayload>) => {
    switch (action.type) {
      case STORE_RESULT_LIDZOEKEN:
      {
        return {
          results: updateResults(state.results, action.payload.results),
          hasMoreResults: action.payload.results[0].HasMoreResults,
          pageNumber: action.payload.results[0].PageNumber,
          totalAmountOfResults: action.payload.results[0].TotalAmountOfResults,
          isSearching: false,
          isSearchInitialised: true,

          zoekenOp: action.payload.zoekenOp || "",
          lidnummer: action.payload.lidnummer || "",
          postcode:  action.payload.postcode || "",
          huisnummer:  action.payload.huisnummer || "",
          geboortedatum:  action.payload.geboortedatum || "",
          searchValue: action.payload.searchValue || "",
          formName: action.payload.formName || "",
          additionalFormData : {
            ...action.payload.additionalData
          }
        };
      }
      case CLEAR_LIDZOEKEN:
        let newState = {
          ...state,
          isSearchInitialised: false,
          zoekenOp: undefined,
          lidnummer: undefined,
          postcode: undefined,
          huisnummer: undefined,
          geboortedatum: undefined,
          searchValue: undefined,
          formName: undefined,
          qrcode: undefined,
          additionalFormData: {}
        };
        if(action.payload !== undefined && state.pageNumber > 1){
          newState.results = state.results;
        }
        return newState;
      case START_LIDZOEKEN : 
        return {
          ...state,
          zoekenOp: undefined,
          searchValue: undefined,
          isSearching: true,
          isSearchInitialised: true,
          lidnummer: undefined,
          postcode: undefined,
          huisnummer: undefined,
          geboortedatum: undefined,
          formName: undefined,
          additionalFormData: {}
        };
      case STOP_LIDZOEKEN : 
        return {
          ...state,
          isSearching: false,
          zoekenOp: undefined,
          lidnummer: undefined,
          postcode: undefined,
          huisnummer: undefined,
          geboortedatum: undefined,
          searchValue: undefined,
          formName: undefined,
          additionalFormData: {}
        };
      case SET_CONSENT_LIDZOEKEN : 
        return {
          ...state,
          results: state.results.map((result) => {
            let resultClone = {...result};
            if (resultClone.PersoonsId == action.payload.id
              || (resultClone.result && resultClone.result.FormGuid == action.payload.id)
              || (resultClone.EmailLead === action.payload.id)) {
              resultClone.LidgaatAkkoord = action.payload.consent;
            }
            return resultClone;
          })
        };

      case PASSTHROUGH_FIELD_LIDZOEKEN : 
        return {
          ...state,
          additionalFormData: {
            ...state.additionalFormData,
            [action.payload.fieldName] : action.payload.value
          }
        };
      default:
        return state;
    }
};
